'use client'

import { useEffect, useRef, useState } from 'react'

export default function Services() {
  const [isVisible, setIsVisible] = useState(false)
  const sectionRef = useRef<HTMLElement>(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true)
          }
        })
      },
      { threshold: 0.1 }
    )

    const currentSection = sectionRef.current

    if (currentSection) {
      observer.observe(currentSection)
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection)
      }
    }
  }, [])

  return (
    <section id="services" className="services-section" ref={sectionRef}>
      <div className="container">
        <h2 className="services-section-title font-logo">Services We Offer</h2>
        <div className="services-grid">
          <div
            className={`service-card ${isVisible ? 'service-card-animate-left' : ''}`}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0) scale(1)'
            }}
          >
            <div className="service-icon icon-line-draw">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3 className="service-title font-logo">TECHNICAL SKILLS</h3>
            <div className="service-separator"></div>
            <ul className="service-list">
              <li>AI Integration (GPT, Claude)</li>
              <li>Machine Learning</li>
              <li>E-commerce</li>
              <li>Cloud Infrastructure</li>
              <li>AWS Cloud Consulting</li>
              <li>AWS Cloud Configuration</li>
              <li>Quality Assurance</li>
              <li>Google Analytics</li>
              <li>Service Monitoring</li>
              <li>API Integration</li>
              <li>Reporting</li>
              <li>Programming</li>
              <li>Web Development</li>
              <li>Software Development</li>
              <li>Project Management</li>
              <li>Product Management</li>
              <li>Database Design</li>
              <li>DevOps</li>
              <li>Automation</li>
            </ul>
          </div>
          <div
            className="service-card service-card-highlighted"
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0) scale(1)'
            }}
          >
            <div className="service-icon icon-line-draw">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                <circle cx="12" cy="12" r="7" stroke="currentColor" strokeWidth="1.5" strokeDasharray="2 2" />
                <path d="M12 2V6M12 18V22M22 12H18M6 12H2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <circle cx="12" cy="12" r="2" fill="currentColor" />
              </svg>
            </div>
            <h3 className="service-title font-logo">OUR PRICING</h3>
            <div className="service-separator"></div>
            <div className="service-desc">
              <p>
                <strong>$0 upfront.</strong> We invest in building your solution first—you only pay when it is live and delivering value. No deposits, no milestones, no financial risk on your end.
              </p>
              <p>
                After launch, pay only for what you use. Maintenance, updates, and support are included—no surprise invoices, no hidden fees. <em>Most clients save 40-60% compared to traditional development contracts.</em>
              </p>
            </div>
          </div>
          <div
            className={`service-card ${isVisible ? 'service-card-animate-right' : ''}`}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0) scale(1)'
            }}
          >
            <div className="service-icon icon-line-draw">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="3" width="7" height="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <rect x="14" y="3" width="7" height="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <rect x="14" y="14" width="7" height="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <rect x="3" y="14" width="7" height="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3 className="service-title font-logo">TECH STACK</h3>
            <div className="service-separator"></div>
            <ul className="service-list">
              <li>JavaScript</li>
              <li>Python</li>
              <li>ReactJS & VueJS</li>
              <li>SQL (Postgres)</li>
              <li>NoSQL (DynamoDB)</li>
              <li>HTML & CSS/SASS</li>
              <li>Bootstrap</li>
              <li>Tailwind</li>
              <li>NodeJS & TypeScript</li>
              <li>WebGL & Three.js</li>
              <li>Bash</li>
              <li>AWS</li>
              <li>Async IO & asyncpg</li>
              <li>Terraform</li>
              <li>FastAPI & Flask</li>
              <li>...and more</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}
